$(document).ready(function () {
    // Получаем текущую локаль
    let userLocale = new Intl.Locale("ru-RU");
    const htmlLang = $("html").attr("lang");
  
    if (htmlLang) {
      userLocale = new Intl.Locale(htmlLang);
    }
  
    const currentDate = new Date();
    const dateAfter15Minutes = addMinutes(currentDate, 15);
  
    // Вставляем дату и время на 15 минут вперёд
    $(".tpl-sys-time-15min").html(
      dateAfter15Minutes.toLocaleString(userLocale, {
        hour: "numeric",
        minute: "numeric",
      })
    );
  
    // Вставляем текущую дату в формате локали
    $(".tpl-sys-current-date").html(formatDate(currentDate, userLocale));
  
    // Форматирует дату в зависимости от языка
    function formatDate(date, locale) {
      if (locale.language === "en") {
        const month = date.toLocaleString(locale, { month: "long" });
        const day = date.toLocaleString(locale, { day: "numeric" });
        return `${month} ${getOrdinalSuffix(day)}`;
      }
  
      return date.toLocaleDateString(locale, {
        day: "numeric",
        month: "long",
      });
    }
  
    // Добавляет минуты к дате
    function addMinutes(date, minutes) {
      return new Date(date.getTime() + minutes * 60 * 1000);
    }
  
    // Возвращает порядковое окончание для английских чисел
    function getOrdinalSuffix(day) {
      const d = parseInt(day);
      if (d > 3 && d < 21) return `${d}th`;
      switch (d % 10) {
        case 1: return `${d}st`;
        case 2: return `${d}nd`;
        case 3: return `${d}rd`;
        default: return `${d}th`;
      }
    }
  });
  